import React, { createContext, useContext, useState, useCallback } from 'react';
import { getUserFriendlyMessage } from '../utils/errorMessages';

const ErrorContext = createContext();

export function useError() {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within ErrorProvider');
  }
  return context;
}

export function ErrorProvider({ children }) {
  const [error, setError] = useState(null);

  const showError = useCallback((err) => {
    const message = typeof err === 'string' ? err : getUserFriendlyMessage(err);
    console.error('App error:', err);
    setError(message);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
}
